import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SolutionOverview } from './components/SolutionOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchases } from './components/RecentPurchases';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '794641966815768');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans selection:bg-mint/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <SolutionOverview data-id="element-4" />
      <Tomos data-id="element-5" />
      <Bonuses data-id="element-6" />
      <OfferSection data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
      <RecentPurchases data-id="element-12" />
    </div>;
}